/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React, { useRef, useState } from 'react';

import classNames from 'classnames';
import threeDots from '../../assets/images/my-library/threeDots.svg';

import Tooltip from '../Tooltip';
import useOnClickOutside from '../../hooks/useOnClickOutside';
import classes from './styles.module.scss';

export default function DropdownMenu({
  options,
  isTrashBin,
  children,
  menuStyle,
  triggerWidth,
  disabled,
  disabledTooltip,
}) {
  const [isActionsMenuVisible, setIsActionsMenuVisible] = useState(false);

  const menuRef = useRef(null);
  const actionsRef = useRef(null);

  useOnClickOutside(menuRef, () => setIsActionsMenuVisible(false), actionsRef);

  return (
    <div
      ref={actionsRef}
      className={classNames(classes.DropdownMenu, {
        [classes.trashBin]: isTrashBin,
      })}
    >
      {children ? (
        <div
          onClick={(e) => {
            e.stopPropagation();
            setIsActionsMenuVisible((prevState) => !prevState);
          }}
          className={classes.button}
          style={{
            width: triggerWidth || '',
            cursor: 'pointer',
          }}
          role="button"
          tabIndex={0}
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              setIsActionsMenuVisible((prevState) => !prevState);
            }
          }}
        >
          {children}
        </div>
      ) : (() => {
        const triggerButton = (
          <button
            onClick={(e) => {
              e.stopPropagation();
              if (!disabled) {
                setIsActionsMenuVisible((prevState) => !prevState);
              }
            }}
            type="button"
            className={classNames(classes.button, { [classes.disabled]: disabled })}
            disabled={disabled}
            style={{
              width: triggerWidth || '',
            }}
          >
            <img src={threeDots} alt="Actions" />
          </button>
        );

        return disabled && disabledTooltip
          ? <Tooltip text={disabledTooltip} position="left">{triggerButton}</Tooltip>
          : triggerButton;
      })()}

      <div
        ref={menuRef}
        className={classNames(classes.menu, {
          [classes.isVisible]: isActionsMenuVisible,
        })}
        style={menuStyle}
      >
        <ul>
          {options.map((option) => (
            <li key={option.label} onClick={(e) => e.stopPropagation()}>
              <button
                className={classes.button}
                onClick={() => {
                  option.onClick();
                  setIsActionsMenuVisible(false);
                }}
                disabled={option.disabled}
                type="button"
              >
                {option.label}
                {option.icon}
              </button>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}
